// extracted by mini-css-extract-plugin
export default {"disclaimer":"OfferDeadlineDisclaimer_disclaimer__g4Btm"};